module.exports = __webpack_public_path__ + "img/btn_app_store.f553f8b7.svg";